import React from "react";
import SurveyTable from "./SurveyTable";
import {Link} from "react-router-dom";
function Survey() {
  return (
    <>
      <div className="container container-xxl">
        <div className="pagetitle d-flex justify-content-between">
          <h1><i className="bi bi-clipboard-data"></i> Surveys</h1>
          <div>
            <Link to="/surveys/new" className="btn btn-sm btn-outline-primary me-2">
              <i className="bi bi-plus"></i> Create New Survey
            </Link>

          </div>
        </div>
        <div className="card">
          <div className="card-body p-2">
            <SurveyTable />
          </div>
        </div>
      </div>
    </>
  );
}

export default Survey;
